<template>
  <div class="row">

    <div class="col-xs-12" v-if="item === 'firm_requirements'">
      <h5 class="col-xs-8">FCA firm Information <span class="small">Requirements</span></h5>
      <template v-if="firmDataReceived" v-for="firmRequirement in firmData">
        <table class="table table-striped">
          <tbody>
          <tr>
            <th>
              <p>Effective Date</p>
            </th>
            <td>
              <p>{{ firmRequirement.effective_date }}</p>
            </td>
          </tr>
          <tr>
            <th>
              <p>{{ firmRequirement.key }}</p>
            </th>
            <td>
              <p>{{ firmRequirement.value }}</p>
            </td>
          </tr>
          </tbody>
        </table>
      </template>
      <p v-if="!firmDataReceived">Not yet uploaded</p>
    </div>


    <div class="col-xs-12" v-if="item === 'firm_regulators'">
      <h5 class="col-xs-8">FCA firm Information <span class="small">Regulators</span></h5>
      <template v-if="firmDataReceived" v-for="firmRegulator in firmData">
        <table class="table table-striped">
          <tbody>
          <tr>
            <th>
              <p>Termination date</p>
            </th>
            <td>
              <p>{{ firmRegulator.termination_date }}</p>
            </td>
          </tr>
          <tr>
            <th>
              <p>Effective date</p>
            </th>
            <td>
              <p>{{ firmRegulator.effective_date }}</p>
            </td>
          </tr>
          <tr>
            <th>
              <p>Regulator name</p>
            </th>
            <td>
              <p>{{ firmRegulator.regulator_name }}</p>
            </td>
          </tr>
          </tbody>
        </table>
      </template>
      <p v-if="!firmDataReceived">Not yet uploaded</p>
    </div>


    <div class="col-xs-12" v-if="item === 'firm_passports'">
      <h5 class="col-xs-8">FCA firm Information <span class="small">Passports</span></h5>
      <template v-if="firmDataReceived" v-for="firmPassport in firmData">
        <table class="table table-striped">
          <tbody>
          <tr>
            <th>
              <p>Passport direction</p>
            </th>
            <td>
              <p>{{ firmPassport.passport_direction }}</p>
            </td>
            <td>
            </td>
          </tr>
          <tr>
            <th>
              <p>Country</p>
            </th>
            <td>
              <p>{{ firmPassport.country }}</p>
            </td>
            <td></td>
          </tr>
          <tr v-for="permission in firmPassport.firm_passport_permissions">
            <th>Permission : </th>
            <td>
              <p><b>Passport type: </b>{{permission.passport_type}}</p>
              <p><b>Passport direction: </b>{{permission.passport_direction}}</p>
              <p><b>Directive: </b>{{permission.directive}}</p>
            </td>
            <td>
              <ul>
                <li v-for="p in permission.permissions">
                  <p><b>Name :</b> {{p.Name}}</p>
                  <template v-if="p.InvestmentTypes.length > 0">
                    <p><b>InvestmentTypes: </b></p>
                    <p v-for="it in p.InvestmentTypes" style="margin-left: 5px"> - {{it}}</p>
                  </template>
                </li>
              </ul>
            </td>
          </tr>
          </tbody>
        </table>
      </template>
      <p v-if="!firmDataReceived">Not yet uploaded</p>
    </div>


    <div class="col-xs-12" v-if="item === 'firm_waivers'">
      <h5 class="col-xs-8">FCA firm Information <span class="small">Waivers</span></h5>
      <template v-if="firmDataReceived" v-for="firmWaiver in firmData">
        <table class="table table-striped">
          <tbody>
          <tr>
            <th>
              <p>Waivers Discretions URL</p>
            </th>
            <td>
              <p><a :href="firmWaiver.waivers_discretions_url" target="_blank">{{ firmWaiver.waivers_discretions_url }}</a></p>
            </td>
          </tr>
          <tr>
            <th>
              <p>Waivers Discretions</p>
            </th>
            <td>
              <p>{{ firmWaiver.waivers_discretions }}</p>
            </td>
          </tr>
          <tr>
            <th>
              <p>Rule Article No</p>
            </th>
            <td>
              <ul>
                <li v-for="item in firmWaiver.rule_article_no">{{ item }}</li>
              </ul>
            </td>
          </tr>
          </tbody>
        </table>
      </template>
      <p v-if="!firmDataReceived">Not yet uploaded</p>
    </div>


    <div class="col-xs-12" v-if="item === 'firm_exclusions'">
      <h5 class="col-xs-8">FCA firm Information <span class="small">Exclusions</span></h5>
      <template v-if="firmDataReceived" v-for="firmExclusion in firmData">
        <table class="table table-striped">
          <tbody>
          <tr>
            <th>
              <p>PSD2 Exclusion Type</p>
            </th>
            <td>
              <p>{{ firmExclusion.psd2_exclusion_type }}</p>
            </td>
          </tr>
          <tr>
            <th>
              <p>Particular Exclusion relied upon</p>
            </th>
            <td>
              <p>{{ firmExclusion.particular_exclusion_relied_upon }}</p>
            </td>
          </tr>
          <tr>
            <th>
              <p>Description of services</p>
            </th>
            <td>
              <p>{{ firmExclusion.description_of_services }}</p>
            </td>
          </tr>
          </tbody>
        </table>
      </template>
      <p v-if="!firmDataReceived">Not yet uploaded</p>
    </div>


    <div class="col-xs-12" v-if="item === 'firm_disciplinary_histories'">
      <h5 class="col-xs-8">FCA firm Information <span class="small">Disciplinary Histories</span></h5>
      <template v-if="firmDataReceived" v-for="firmDisciplinaryHistory in firmData">
        <table class="table table-striped">
          <tbody>
          <tr>
            <th>
              <p>Action effective from</p>
            </th>
            <td>
              <p>{{ firmDisciplinaryHistory.action_effective_from }}</p>
            </td>
          </tr>
          <tr>
            <th>
              <p>Enforcement type</p>
            </th>
            <td>
              <p>{{ firmDisciplinaryHistory.enforcement_type }}</p>
            </td>
          </tr>
          <tr>
            <th>
              <p>Type of action</p>
            </th>
            <td>
              <p>{{ firmDisciplinaryHistory.type_of_action }}</p>
            </td>
          </tr>
          <tr>
            <th>
              <p>Type of description</p>
            </th>
            <td>
              <p>{{ firmDisciplinaryHistory.type_of_description }}</p>
            </td>
          </tr>
          </tbody>
        </table>
      </template>
      <p v-if="!firmDataReceived">Not yet uploaded</p>
    </div>


    <div class="col-xs-12" v-if="item === 'firm_appointed_representatives'">
      <h5 class="col-xs-8">FCA firm Information <span class="small">Appointed Representatives</span></h5>
      <template v-if="firmDataReceived" v-for="firmAppointedRepresentative in firmData">
        <table class="table table-striped">
          <tbody>
          <tr v-for="(value, key) in firmAppointedRepresentative.data">
            <template v-if="inArray(key, ['FRN','Name','Tied Agent','Principal FRN','RecordSubType','EEA Tied Agent','Effective Date','Termination Date','Principal Firm Name','[NotinUse] Insurance Distribution'])">
              <th>
                <p>{{ key}}</p>
              </th>
              <td>
                <p>{{ value }}</p>
              </td>
            </template>
          </tr>
          </tbody>
        </table>
      </template>
      <p v-if="!firmDataReceived">Not yet uploaded</p>
    </div>



    <div class="col-xs-12" v-if="item === 'firm_products'">


      <h5 class="col-xs-8">FCA Firm Product Reference Number</h5>
      <div class="col-xs-4">
        <h4 v-if="!accountId"><input id="prn" name="prn" type="text" v-model="firmProductNumber" /></h4>
        <h4 v-else>{{firmProductNumber}}</h4>
        <template v-if="!accountId && firmProductNumber">
          <a type="button" @click="updateFcaProductsData">
            <i class="fa fa-refresh"></i>
          </a>
          <span> Please click to reload FCA Firm Product data</span>
        </template>
      </div>


      <h5 class="col-xs-8">FCA firm Information <span class="small">Products</span></h5>
      <template v-if="!updatedMessage">
      <template v-if="firmDataReceived" v-for="firmProduct in firmData">
        <table class="table table-striped">
          <tbody>
          <tr>
            <th>
              <p>CIS depositary</p>
            </th>
            <td>
              <p>{{ firmProduct.cis_depositary }}</p>
            </td>
          </tr>
          <tr>
            <th>
              <p>CIS depositary name</p>
            </th>
            <td>
              <p>{{ firmProduct.cis_depositary_name }}</p>
            </td>
          </tr>
          <tr>
            <th>
              <p>Effective date</p>
            </th>
            <td>
              <p>{{ firmProduct.effective_date }}</p>
            </td>
          </tr>
          <tr>
            <th>
              <p>ICVC registration no</p>
            </th>
            <td>
              <p>{{ firmProduct.icvc_registration_no }}</p>
            </td>
          </tr>
          <tr>
            <th>
              <p>Product type</p>
            </th>
            <td>
              <p>{{ firmProduct.product_type }}</p>
            </td>
          </tr>
          <tr>
            <th>
              <p>Scheme type</p>
            </th>
            <td>
              <p>{{ firmProduct.scheme_type }}</p>
            </td>
          </tr>
          <tr>
            <th>
              <p>Status</p>
            </th>
            <td>
              <p>{{ firmProduct.status }}</p>
            </td>
          </tr>
          </tbody>
        </table>

        <h5 class="col-xs-8">FCA firm Information <span class="small">Product Sub-fund</span></h5>
        <table class="table table-striped">
          <thead>
          <tr>
            <th>
              Name
            </th>
            <th>
              Sub-fund type
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="firmProductSubfund in firmProduct.firm_product_subfunds">
            <th>
              <p>{{ firmProductSubfund.name }}</p>
            </th>
            <td>
              <p>{{ firmProductSubfund.sub_fund_type }}</p>
            </td>
          </tr>
          </tbody>
        </table>

        <h5 class="col-xs-8">FCA firm Information <span class="small">product other names</span></h5>
        <table class="table table-striped">
          <thead>
          <tr>
            <th>
              Product other name
            </th>
            <th>
              Effective from
            </th>
            <th>
              Effective to
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="firmProductOtherName in firmProduct.firm_product_other_names">
            <th>
              <p>{{ firmProductOtherName.product_other_name }}</p>
            </th>
            <th>
              <p>{{ firmProductOtherName.effective_from }}</p>
            </th>
            <td>
              <p>{{ firmProductOtherName.effective_to }}</p>
            </td>
          </tr>
          </tbody>
        </table>

      </template>
      </template>
      <template v-else>
        <div class="col-xs-12">
          <h5 class="col-xs-8">{{updatedMessage}}</h5>
        </div>
      </template>
      <p v-if="!firmDataReceived">Not yet uploaded</p>
    </div>
  </div>
</template>

<script>
import {string} from "yup";

export default {
  name: "FCAFirmShowDataComponent",

  props: {
    csrfToken: {
      required: true,
      type: String,
    },
    data: {
      required: true,
      type: Array,
    },
    prn: {
      required: true,
      type: String,
    },
    item: {
      required: true,
      type: String,
    },
    accountId: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      firmData: this.data,
      firmDataReceived: this.data.length > 0,
      firmProductNumber: this.prn,
      updatedMessage: null,
    }
  },
  methods: {
    updateFcaProductsData() {
      axios.get(`/fca/process-products/${this.firmProductNumber}`).then((res) => {
        this.firmDataReceived = false;
        this.updatedMessage = 'FCA register updating ...';
        setTimeout(() => {
          window.location.reload();
        }, 180000);
      }).catch((error) => {
        console.log('error', error)
      })
    },
    inArray(needle, haystack) {
      return haystack.includes(needle);
    },
  },
}
</script>

<style scoped>
:not(.input-group-btn) > .btn {
  padding: 2px 8px;
  border-radius: 0;
  margin: 0;
  background-color: #73C2AF;
}
</style>